import { usePutMutation } from "@/api/swr/useMutation";
import { companyUserProfileEditSchema } from "@/schema/app/profile/CompanyUser";
import { z } from "zod";

type Config = Parameters<typeof usePutMutation<typeof companyUserProfileEditSchema, z.ZodUndefined>>[3];

export const useEditCompanyUserProfile = (config?: Config) => {
  return usePutMutation(
    companyUserProfileEditSchema,
    z.undefined(),
    `/app/company_users/profile/update`,
    config,
  );
};
